import React, { useRef, useCallback} from 'react';
import { MdFileUpload, MdCloudUpload, MdCheckCircle, MdCancel, MdClose, MdInsertDriveFile, MdDownloadForOffline } from 'react-icons/md';
import { KeyboardDateTimePicker } from "@material-ui/pickers";
import { MultipleSelect } from '../../../Plugin/component';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import { NotificationManager } from 'react-notifications';
import { Spin } from "react-cssfx-loading";
import TextField from '@material-ui/core/TextField';
import Autocomplete from "@material-ui/lab/Autocomplete";
import Typography from '@material-ui/core/Typography';
import ClassicEditor from 'ckeditor5-build-classic-full-option';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import Checkbox from '@material-ui/core/Checkbox';
import './styles.scss';
import { Select } from 'antd';

export default function LayoutBody(props) {

    const {currentEmailAzure = [], currentValue = [], handleGetInputTextAzureEmail = () => {}, handleUpdateStateDataPlanHandle = () => {}} = props

    const [open, setOpen] = React.useState(false);
    const [data, setData] = React.useState();
    const [index, setIndex] = React.useState();
    const [disabled, setDisabled] = React.useState(false);
    const [isRemoveInputFile, setIsRemoveInputFile] = React.useState(false)

    const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
    const checkedIcon = <CheckBoxIcon fontSize="small" />;

    const handleRemoveInputFile = (isRemove) => {
        setData()
        setOpen(false)
        if (props.isPlanHandleByStep) {
            props.handleDeleteFile(data, index)
        } else {
            props.onChange("", index, "RemoveFile")
            if (!isRemove) {
                setIsRemoveInputFile(true)
            } else {
                setIsRemoveInputFile(false)
            }
        }
    }

    const Data = React.useRef();

    React.useEffect(() => {
        if (Data !== props.data) {
            Data.current = props.data;
            if (index) {
                setData(props.data[index].content)
            }
        }
        // eslint-disable-next-line
    }, [props.data])

    const isRequiredText = useCallback((item) => item.isRequired === "true" ? true : false, []);

    const includedHelperText = useCallback((item) => {
        return item.isError && `Vui lòng điền vào trường ${item.name}`
    }, [])

    const handleClickOpen = useCallback((value, index, disabled) => {
        setData(value);
        setIndex(index)
        setOpen(true);
        setDisabled(disabled);
    }, []);

    const handleClose = useCallback(() => {
        setOpen(false);
    }, []);

    const onChange = useCallback((value, index, type) => {
        props.onChange(value, index, type)
        // eslint-disable-next-line
    }, []);

    const handleDownload = useCallback((value) => {
        props.handleDownload(value)
        // eslint-disable-next-line
    }, []);

    const reflbl = useRef([]);
    const refcls = useRef([]);

    reflbl.current = props.data.map((element, i) => reflbl.current[i] ?? React.createRef());
    refcls.current = props.data.map((element, i) => refcls.current[i] ?? React.createRef());

    return <div className="row layout-body col-md-12">
        {props.data.map((item, index) => {
            //console.log("layout-body",item);        
            let layoutByItem;
            if (item.type !== "Link liên kết") {
                if (item.type === "Input text") {
                    layoutByItem = <TextField
                        fullWidth
                        id="outlined-name"
                        label={item.name}
                        margin="dense"
                        variant="outlined"
                        InputLabelProps={{
                            shrink: true,
                        }}
                        onChange={(e) => props.onChange(e.target.value, index, item.type, item.planTypeConfigurationID)}
                        value={item.content ? item.content : ""}
                        disabled={item.disabled === 1 ? true : false}
                        required={isRequiredText(item)}
                        error={item.isError}
                        helperText={includedHelperText(item)}
                    />
                }
                else if (item.type === "Link") {
                    if (item.disabled !== 1) {
                        layoutByItem = <TextField
                            fullWidth
                            id="outlined-name"
                            label={item.name}
                            margin="dense"
                            variant="outlined"
                            InputLabelProps={{
                                shrink: true,
                            }}
                            onChange={(e) => props.onChange(e.target.value, index, item.type, item.planTypeConfigurationID)}
                            value={item.content ? item.content : ""}
                            required={isRequiredText(item)}
                            error={item.isError}
                        />
                    }
                    else {
                        layoutByItem = <div className="layout-link">
                            <span className="layout-title">{item.name}</span>
                             {/* eslint-disable-next-line */}
                            <a href={item.content} target="_blank"><span>{item.content}</span></a>
                        </div>
                    }
                }
                else if (item.type === "Datetime") {
                    layoutByItem = <KeyboardDateTimePicker
                        fullWidth
                        animateYearScrolling
                        format="dd/MM/yyyy HH:mm"
                        mask="___/__/__ __:__ _M"
                        label={item.name}
                        inputVariant="outlined"
                        margin="dense"
                        InputLabelProps={{
                            shrink: true,
                        }}
                        value={item.content ? item.content : new Date()}
                        onChange={(e) => props.onChange(e, index, item.type, item.planTypeConfigurationID)}
                        disabled={item.disabled === 1 ? true : false}
                        required={isRequiredText(item)}
                        error={item.isError}
                    />
                }
                else if (item.type === "Combobox") {
                    layoutByItem = <Autocomplete
                        options={item.data.split('*')}
                        size="small"
                        getOptionLabel={(option) => option}
                        style={{ width: "100%" }}
                        renderInput={(params) => <TextField {...params} InputLabelProps={{
                            shrink: true,
                        }}
                            margin="dense"
                            label={item.name}
                            variant="outlined" />}
                        renderOption={(option) => <Typography noWrap style={{ fontSize: "14px" }}>{option}</Typography>}
                        value={item.content ? item.content : null}
                        onChange={(e, newValue) => props.onChange(newValue, index, item.type, item.planTypeConfigurationID)}
                        disabled={item.disabled === 1 ? true : false}
                        required={isRequiredText(item)}
                        error={item.isError}
                    />
                }
                //fproject   project name             
                else if (item.type === "Combobox1") {
                    layoutByItem = <Autocomplete
                        options={item.data ? JSON.parse(item.data) : []}
                        size="small"
                        getOptionLabel={(option) => option.identifier}
                        style={{ width: "100%" }}
                        renderInput={(params) => <TextField {...params} InputLabelProps={{
                            shrink: true,
                        }}
                            margin="dense"
                            label={item.name}
                            variant="outlined"
                            placeholder={item.placeholder} />}
                        renderOption={(option) => <Typography noWrap style={{ fontSize: "14px" }}>{option.identifier}</Typography>}
                        value={item.content ? item.content : null}
                        onChange={(e, newValue) => props.onChange(newValue, index, item.type, item.planTypeConfigurationID)}
                        disabled={item.disabled === 1 ? true : false}
                        required={isRequiredText(item)}
                        error={item.isError}
                    />
                }
                //fproject project phong ban  
                else if (item.type === "Combobox2") {
                    layoutByItem = <Autocomplete
                        options={item.data ? JSON.parse(item.data) : []}
                        size="small"
                        getOptionLabel={(option) => option.department_name}
                        style={{ width: "100%" }}
                        renderInput={(params) => <TextField {...params} InputLabelProps={{
                            shrink: true,
                        }}
                            margin="dense"
                            label={item.name}
                            variant="outlined"
                            placeholder={item.placeholder} />}
                        renderOption={(option) => <Typography noWrap style={{ fontSize: "14px" }}>{option.department_name}</Typography>}
                        value={item.content ? item.content : null}
                        onChange={(e, newValue) => props.onChange(newValue, index, item.type, item.planTypeConfigurationID)}
                        disabled={item.disabled === 1 ? true : false}
                        required={isRequiredText(item)}
                        error={item.isError}
                    />
                }
                //fproject PM 
                else if (item.type === "Combobox3") {
                    layoutByItem = <Autocomplete
                        options={item.data ? JSON.parse(item.data) : []}
                        size="small"
                        getOptionLabel={(option) => option.user_name}
                        style={{ width: "100%" }}
                        renderInput={(params) => <TextField {...params} InputLabelProps={{
                            shrink: true,
                        }}
                            margin="dense"
                            label={item.name}
                            variant="outlined"
                            placeholder={item.placeholder} />}
                        renderOption={(option) => <Typography noWrap style={{ fontSize: "14px" }}>{option.user_name}</Typography>}
                        value={item.content ? item.content : null}
                        onChange={(e, newValue) => props.onChange(newValue, index, item.type, item.planTypeConfigurationID)}
                        disabled={item.disabled === 1 ? true : false}
                        required={isRequiredText(item)}
                        error={item.isError}
                    />
                } 
                else if (item.type === "Combobox4") {
                    layoutByItem = <Autocomplete
                        options={item.data ? JSON.parse(item.data) : []}
                        size="small"
                        getOptionLabel={(option) => option.gitLab}
                        style={{ width: "100%" }}
                        renderInput={(params) => <TextField {...params} InputLabelProps={{
                            shrink: true,
                        }}
                            margin="dense"
                            label={item.name}
                            variant="outlined"
                            placeholder={item.placeholder} />}
                        renderOption={(option) => <Typography noWrap style={{ fontSize: "14px" }}>{option.gitLab}</Typography>}
                        value={item.content ? item.content : null}
                        onChange={(e, newValue) => props.onChange(newValue, index, item.type, item.planTypeConfigurationID)}
                        disabled={item.disabled === 1 ? true : false}
                        required={isRequiredText(item)}
                        error={item.isError}
                    />
                }
                else if (item.type === "Combobox5") {
                    layoutByItem = <Autocomplete
                        options={item.data ? JSON.parse(item.data) : []}
                        size="small"
                        getOptionLabel={(option) => option.user_name}
                        style={{ width: "100%" }}
                        renderInput={(params) => <TextField {...params} InputLabelProps={{
                            shrink: true,
                        }}
                            margin="dense"
                            label={item.name}
                            variant="outlined"
                            placeholder={item.placeholder} />}
                        renderOption={(option) => <Typography noWrap style={{ fontSize: "14px" }}>{option.user_name}</Typography>}
                        value={item.content ? item.content : null}
                        onChange={(e, newValue) => props.onChange(newValue, index, item.type, item.planTypeConfigurationID)}
                        disabled={item.disabled === 1 ? true : false}
                        required={isRequiredText(item)}
                        error={item.isError}
                    />
                }
                else if (item.type === "Multiple select") {
                    layoutByItem = <MultipleSelect
                        data={item.data.split('*')}
                        name={item.name}
                        value={item.content ? item.content.split('*') : []}
                        onChange={(Value) => props.onChange(Value.join('*'), index, item.type, item.planTypeConfigurationID)}
                        disabled={item.disabled === 1 ? true : false}
                        required={isRequiredText(item)}
                        error={item.isError}
                    />
                }
                else if (item.type === "Lable") {
                    layoutByItem = <div className="lable-ui">
                        <span>{item.name}</span>
                    </div>
                }
                else if (item.type === "Input text multiline") {
                    layoutByItem = <TextField
                        fullWidth
                        id="outlined-name"
                        label={item.name}
                        margin="dense"
                        variant="outlined"
                        multiline
                        rows={5}
                        InputLabelProps={{
                            shrink: true,
                        }}
                        onChange={(e) => props.onChange(e.target.value, index, item.type, item.planTypeConfigurationID)}
                        value={item.content}
                        disabled={item.disabled === 1 ? true : false}
                        required={isRequiredText(item)}
                        error={item.isError}
                    />
                }
                else if (item.type === "Editor") {
                    layoutByItem = <div className="itsm-editor" ref={refcls.current[index]}>
                        <span ref={reflbl.current[index]} className="editor-title">{item.name}</span>
                        <CKEditor
                            editor={ClassicEditor}
                            data={item.content ? item.content : ""}
                            disabled={item.disabled === 1 ? true : false}
                            onChange={(event, editor) => {
                                const data = editor.getData();
                                props.onChange(data, index, item.type, item.planTypeConfigurationID);
                            }}
                            onFocus={(e) => {
                                reflbl.current[index].current.classList.add('lbl-focus');
                                refcls.current[index].current.classList.add('cls-focus');

                            }}
                            onBlur={(e) => {
                                reflbl.current[index].current.classList.remove('lbl-focus');
                                refcls.current[index].current.classList.remove('cls-focus');
                            }}
                            required={isRequiredText(item)}
                            error={item.isError}
                        />
                    </div>
                }
                else if (item.type === "File") {
                    layoutByItem = <div className="itsm-file" >
                        <span className="itsm-file-title">{item.name}</span>
                        <div className="itsm-file-body" onClick={() => handleClickOpen(item.content, index, item.disabled)}>
                            <span className="itsm-file-value">{item.content}</span>
                            <div className="itsm-file-icon">
                                <MdFileUpload />
                            </div>
                        </div>
                    </div>
                }
                else if (item.type === "Azure Email1") {
                    layoutByItem = <Autocomplete
                    multiple
                    id="checkboxes-tags-demo"
                    size="small"
                    style={{ width: '100%' }}
                    options={currentValue}
                    value={currentEmailAzure.find((val) => val.id === index)?.data || []}
                    onChange={(event, newValue) => {
                        handleUpdateStateDataPlanHandle(newValue, index, item.type);
                    }}
                    disableCloseOnSelect
                    getOptionLabel={(option) => option ? option : ''}
                    renderOption={( option, { selected }) => (
                        <>
                            <Checkbox
                            icon={icon}
                            checkedIcon={checkedIcon}
                            style={{ marginRight: 8 }}
                            checked={selected}
                            />
                            {option}
                        </>
                    )}
                    renderInput={(params) => {
                      return (<TextField
                        //value={hihi}
                        {...params}
                        label={item.name}
                        placeholder={item.placeholder}
                        variant="outlined"
                        onChange={(e) => 
                            handleGetInputTextAzureEmail(e)
                        }
                        // onChange={handleGetInput}
                      />)
                    }}
                    disabled={item.disabled === 1 ? true : false}
                    required={isRequiredText(item)}
                    error={item.isError}
                  />
                    
                } 
                else if (item.type === "Azure Email") {
                    layoutByItem = <Select
                    mode="multiple"
                    allowClear
                    style={{ width: '100%' }}
                    placeholder="Please select"
                    // defaultValue={['a10', 'c12']}
                    onChange={(event) => handleUpdateStateDataPlanHandle(event, index, item.type)}
                    options={currentValue}
                    onSearch={handleGetInputTextAzureEmail}
                  />
                    
                }
            }
            return <div key={index} className={"col-md-" + item.flex} style={{ marginBottom: "10px" }}>
                {layoutByItem}
            </div>
        })}
        <UploadFileDialog open={open} handleClose={handleClose} data={data} index={index} disabled={disabled} onChange={onChange} handleDownload={handleDownload} onDeleteFile={() => handleRemoveInputFile(isRemoveInputFile)} />
    </div>
}

const UploadFileDialog = React.memo((props) => {

    const refUploadFile = useRef();
    const [fileList, setFileList] = React.useState();
    const [isLoading, setIsLoading] = React.useState(false);
    const [data, setData] = React.useState();
    const isRemoveInputFile = false

    React.useEffect(() => {
        if (props.data) {
            setData([...props.data])
        }
        // eslint-disable-next-line
    }, [])

    React.useEffect(() => {
        if (!props.open) {
            setFileList();
        }
    }, [props.open])

    React.useEffect(() => {
        if (props.data) {
            setData([...props.data])
        }
        else {
            setData();
        }
    }, [props.data])

    const HandleCheckInvalidFile = useCallback((fileList) => {
        // eslint-disable-next-line
        Array.from(fileList).map(file => {
            if (file.size > 25000000) {
                NotificationManager.error("Dung lượng file quá lớn")
            } else if (file.name.length > 120) {
                NotificationManager.error("Tên file quá dài")
            }
        })
        // eslint-disable-next-line
    }, [fileList])

    return <Dialog
        open={props.open}
        onClose={props.handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className="upload-file-tab-dialog"
    >
        <div className="upload-file-tab">
            <div className="upload-file-tab-title">
                <span>Chọn file của bạn</span>
                <span className="note">File hợp lệ Zip, Rar (Dung lượng dưới 1MB)</span>
            </div>
            <div className="upload-file-tab-selection" onClick={() => !props.disabled && refUploadFile.current.click()}>
                <MdCloudUpload />
                <span className="note">click để chọn file</span>
            </div>
            {
                data ? <div className="upload-file-tab-list-file" >
                    <MdInsertDriveFile className="file-icon" />
                    <div className="upload-file-tab-list-file-name">
                        <div className="upload-file-tab-list-file-name-top">
                            <span>{props.data}</span>
                        </div>
                        <MdDownloadForOffline className="donwload-icon" onClick={() => props.handleDownload(props.data.split('-')[0])} />
                        <MdCheckCircle className="check-icon" />
                        <MdCancel className="error-icon" onClick={() => props.onDeleteFile(isRemoveInputFile)} />
                    </div>
                </div>
                    :
                    fileList && fileList.map((item, index) => <div className="upload-file-tab-list-file" key={item}>
                        <MdInsertDriveFile className="file-icon" />
                        <div className="upload-file-tab-list-file-name">
                            <div className="upload-file-tab-list-file-name-top">
                                <span>{item.name}</span>
                            </div>
                            {/* {isLoading ? <Spin className="loading-icon" color="var(--itsm-bg-btn)" /> : <MdCancel className="error-icon" />} */}
                            {isLoading && <Spin className="loading-icon" color="var(--itsm-bg-btn)" />}
                        </div>
                    </div>)
            }

            <div className="upload-file-tab-btn-handle">
                <Button
                    onClick={() => {
                        if (fileList) {
                            setIsLoading(true);
                            HandleCheckInvalidFile(fileList)
                            props.onChange(fileList, props.index, "File")
                        }
                        else {
                            NotificationManager.warning("Vui lòng chọn file");
                        }
                    }}
                    className="btn-upload-file"
                    variant="contained"
                    startIcon={<MdFileUpload />}
                >
                    Upload file
                </Button>
                <Button
                    onClick={props.handleClose}
                    className="btn-close"
                    variant="contained"
                    startIcon={<MdClose />}
                >
                    Đóng
                </Button>
            </div>
        </div>
        <input
            accept=".zip,.7zip,.rar"
            id="contained-button-file"
            type="file"
            style={{ display: "none" }}
            ref={refUploadFile}
            onChange={(e) => {
                setData();
                setIsLoading(false);
                setFileList(onChangeFile(e.target.files));
                //props.onChange(onChangeFile(e.target.files), props.index, props.data.type)
            }}
        />
    </Dialog>
});


const onChangeFile = (value) => {
    let FileList = [];

    Array.from(value).forEach(file => {
        const regExp = /[àÀảẢãÃáÁạẠăĂằẰẳẲẵẴắẮặẶâÂầẦẩẨẫẪấẤậẬđĐèÈẻẺẽẼéÉẹẸêÊềỀểỂễỄếẾệỆ ìÌỉỈĩĨíÍịỊòÒỏỎõÕóÓọỌôÔồỒổỔỗỖốỐộỘơƠờỜởỞỡỠớỚợỢ ùÙủỦũŨúÚụỤưƯừỪửỬữỮứỨựỰỳỲỷỶỹỸýÝỵỴ]/
        if (file.type && "zip,application/octet-stream,application/zip,application/x-zip,application/x-zip-compressed".includes(file.type)) {
            if (file.name && regExp.test(file.name)) {
                NotificationManager.warning("File " + file.name + " không được bao gồm Tiếng Việt và dấu cách");
            }
             else if (file.name && file.name.length > 100) {
                NotificationManager.warning("File " + file.name + " quá 100 kí tự");
            }
            else {
                FileList.push(file);
            }
        } else if (file.name && file.name.includes(".rar")) {
            if (regExp.test(file.name)) {
                NotificationManager.warning("File " + file.name + " không được bao gồm Tiếng Việt và dấu cách");
            }
            else if (file.name && file.name.length > 100) {
                NotificationManager.warning("File " + file.name + " quá 100 kí tự");
            } else {
                FileList.push(file);
            }
        }
        else {
            NotificationManager.warning("File " + file.name + " Không đúng định dạng");
        }
    });

    return FileList;
}


